import { CalendarService } from "./../../services/calendar.service";
import {
  CalendarModel,
  HolidayType,
  CalendarHolidaysRequestModel,
} from "./../../model/domain/CalendarModel";
import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { NgForm, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { catchError, map, finalize, flatMap } from "rxjs/operators";
import { of, throwError, Observable } from "rxjs";

import { LoaderService } from "../../services/loader.service";
import { SnackbarService } from "../../services/snackbar.service";
import { DateTime } from "luxon";

@Component({
  selector: "app-calendario",
  templateUrl: "./calendario.component.html",
  styleUrls: ["./calendario.component.css"],
})
export class CalendarioComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private snackBarService: SnackbarService,
    private calendarService: CalendarService
  ) {}

  holidayTypeList: HolidayType[] = [];
  holidayList: CalendarModel[] = [];
  requestModel = new CalendarHolidaysRequestModel();
  registerHolidayModel = new CalendarModel();

  ngOnInit() {
    this.getHolidaysTypeList();
    this.getHolidaysList();
  }

  getHolidaysTypeList() {
    this.calendarService.getHolidaysTypeList().subscribe((res) => {
      this.holidayTypeList = res;
    });
  }

  getHolidaysList() {
    this.holidayList = this.holidayList.splice(0, this.holidayList.length);

    this.calendarService.getHolidaysList().subscribe((res) => {
      this.holidayList = res;
    });
  }

  getFromGateway() {
    const method = this.calendarService.updateHolidays(this.requestModel);

    method
      .pipe(
        catchError((err) => {
          this.snackBarService.open(
            "Ocorreu um erro ao atualizar o calendário"
          );
          return throwError("Ocorreu um erro ao atualizar o calendário");
        })
      )
      .subscribe((res) => {
        this.getHolidaysList();
      });
  }

  registerHoliday() {
    const method = this.calendarService.registerHoliday(
      this.registerHolidayModel
    );

    method
      .pipe(
        catchError((err) => {
          this.snackBarService.open("Ocorreu um erro ao cadastrar o feriado");
          return throwError("Ocorreu um erro ao cadastrar o feriado");
        })
      )
      .subscribe((res) => {
        this.getHolidaysList();
      });
  }

  getFromGatewayButtonDisabled() {
    var currentTime = new Date();

    return (
      this.requestModel.types.length == 0 ||
      this.requestModel.year == null ||
      this.requestModel.year < currentTime.getFullYear() ||
      this.requestModel.year > currentTime.getFullYear() + 100
    );
  }

  registerHolidayButtonDisabled() {
    return (
      this.registerHolidayModel.date == null ||
      this.registerHolidayModel.description == null ||
      this.registerHolidayModel.description == "" ||
      this.registerHolidayModel.typeName == null ||
      this.registerHolidayModel.typeName == ""
    );
  }

  deleteHoliday(id: number) {
    const method = this.calendarService.deleteHoliday(id);

    method
      .pipe(
        catchError((err) => {
          this.snackBarService.open(
            "Ocorreu um erro ao tentar excluir o feriado"
          );
          return throwError("Ocorreu um erro ao tentar excluir o feriado");
        })
      )
      .subscribe((res) => {
        this.snackBarService.open("Feriado excluído com sucesso!");
        this.getHolidaysList();
      });
  }
}
